<template>
  <div class="">
    <div class=" grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
      <div>
        <label for="first_name" class="block text-sm font-medium text-gray-700">
          First Name
        </label>
        <div class="mt-1">
          <input v-model="data.first_name" type="email" class="appearance-none block w-full p-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" :class="{'border-red-500' : errors.first_name}">
        </div>

        <div class="text-red-600 text-sm px-1 py-1" v-if="errors.first_name">
          <i class="fa fa-exclamation-triangle"></i> {{ errors.first_name }}
        </div>
      </div>

      <div>
        <label for="last_name" class="block text-sm font-medium text-gray-700">
          Last Name
        </label>
        <div class="mt-1">
          <input v-model="data.last_name" type="email" class="appearance-none block w-full p-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" :class="{'border-red-500' : errors.last_name}">
        </div>

        <div class="text-red-600 text-sm px-1 py-1" v-if="errors.last_name">
          <i class="fa fa-exclamation-triangle"></i> {{ errors.last_name }}
        </div>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-gray-700">
          Email address
        </label>
        <div class="mt-1">
          <input v-model="data.email" type="email" class="appearance-none block w-full p-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" :class="{'border-red-500' : errors.email}" />
        </div>

        <div class="text-red-600 text-sm px-1 py-1" v-if="errors.email">
          <i class="fa fa-exclamation-triangle"></i> {{ errors.email }}
        </div>
      </div>

      <div>
        <label for="phone" class="block text-sm font-medium text-gray-700">
          Phone No.
        </label>
        <div class="mt-1">
          <input v-model="data.phone" type="text" class="appearance-none block w-full p-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" :class="{'border-red-500' : errors.phone}">
        </div>

        <div class="text-red-600 text-sm px-1 py-1" v-if="errors.phone">
          <i class="fa fa-exclamation-triangle"></i> {{ errors.phone }}
        </div>
      </div>
    </div>

    <div class="text-center border-t mt-4 sm:mt-6 pt-4 sm:pt-6">
      <button type="submit" @click="submitHandler()" :disabled="loading" class="w-full sm:w-auto py-3 px-10 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled-button">
        {{ loading ? 'Submitting...' : 'Submit' }}
      </button>
    </div>
  </div>
</template>

<script>
import WaitingList from "../../services/api/WaitingList.js";
export default {
  data() {
    return {
      data: {},
      errors: {},
      loading: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.data = {
        ...this.data,
        ...{
          email: "",
          first_name: "",
          last_name: "",
          phone: "",
        },
      };
    },
    submitHandler() {
      if (this.validateData()) return;

      this.loading = true;

      window.blockUI();
      WaitingList.store(this.data)
        .then((res) => {
          if (res.data.error == true) {
            flash(res.data.message, "error");
          }

          if (res.data.error == false) {
            flash(res.data.message, "success");
            
            window.location.href = "/waiting-list-confimation";
          }
        })
        .finally(() => {
          this.loading = false;
          window.unblockUI();
        });
    },
    validateData() {
      this.errors = {};
      let error = false;

      var current_year = new Date().getFullYear();

      if (!this.data.email) {
        this.errors.email = true;
        this.errors.email = "Please enter email id.";
        error = true;
      }

      if (!this.data.first_name) {
        this.errors.first_name = true;
        this.errors.first_name = "Please enter first name.";
        error = true;
      }

      if (!this.data.last_name) {
        this.errors.last_name = true;
        this.errors.last_name = "Please enter last name.";
        error = true;
      }

      if (!this.data.phone) {
        this.errors.phone = true;
        this.errors.phone = "Please enter phone no.";
        error = true;
      }

      return error;
    },
  },
};
</script>